import React, { useState, useEffect, useCallback } from "react";
import { Card, CardBody, Button, Input, Spinner } from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import AwesomePagination from "../../Components/Common/AwesomePagination";
import { toast } from "react-toastify";
import ModalCampanha from "./ModalCampanha";
import ModalConfirmacao from "./ModalConfirmacao";
import SidebarCampanha from "./SidebarCampanha";

const apiClient = new APIClient();

const TabCampanhas = () => {
  const [loading, setLoading] = useState(false);
  const [campanhas, setCampanhas] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [busca, setBusca] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [campanhaAtual, setCampanhaAtual] = useState(null);
  const [modalConfirmacaoOpen, setModalConfirmacaoOpen] = useState(false);
  const [campanhaParaDesativar, setCampanhaParaDesativar] = useState(null);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleModalConfirmacao = () =>
    setModalConfirmacaoOpen(!modalConfirmacaoOpen);

  const fetchCampanhas = useCallback(async (currentPage, searchTerm) => {
    setLoading(true);
    const params = {
      itens_pagina: 20,
      pagina: currentPage,
      termo: searchTerm,
    };

    try {
      const response = await apiClient.post(`/campanhas-voucher/busca`, params);
      if (response?.sucesso) {
        const dados = response.dados;
        setCampanhas(dados.data);
        setTotalPaginas(dados.last_page);
      } else {
        toast.error(response.mensagem || "Erro ao buscar campanhas");
      }
    } catch (error) {
      console.error("Erro completo:", error);
      toast.error("Erro ao buscar campanhas");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await fetchCampanhas(pagina, "");
    };
    fetchData();
  }, [pagina, fetchCampanhas]);

  const handleEditarCampanha = (campanha) => {
    setCampanhaAtual(campanha);
    setSidebarOpen(true);
  };

  const handleDesativarCampanha = (campanha) => {
    setCampanhaParaDesativar(campanha);
    setModalConfirmacaoOpen(true);
  };

  const confirmarDesativacao = async () => {
    if (!campanhaParaDesativar) return;

    setLoading(true);
    try {
      const response = await apiClient.put(
        `/campanhas-voucher/${campanhaParaDesativar.id}/desativar`
      );
      if (response?.dados) {
        toast.success("Campanha desativada com sucesso!");
        await fetchCampanhas(pagina, busca);
      } else {
        toast.error(response?.mensagem || "Erro ao desativar campanha");
      }
    } catch (error) {
      toast.error("Erro ao desativar campanha");
    }
    setLoading(false);
    setModalConfirmacaoOpen(false);
    setCampanhaParaDesativar(null);
  };

  return (
    <>
      <Card className="border-0 shadow-sm">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0">Campanhas</h4>
            {campanhas && campanhas.length > 0 && (
              <Button
                color="info"
                className="btn-info text-white fw-semibold"
                onClick={toggleModal}
              >
                Criar Campanha
              </Button>
            )}
          </div>

          {!campanhas || (campanhas.length === 0 && !loading) ? (
            <div className="text-center py-5">
              <div className="text-muted mb-3">
                Você ainda não tem campanhas criadas.
              </div>
              <Button
                color="info"
                className="btn-info text-white fw-semibold"
                onClick={toggleModal}
              >
                Criar Campanha
              </Button>
            </div>
          ) : (
            <>
              <div className="d-flex gap-2 mb-3">
                <Input
                  type="search"
                  placeholder="Buscar campanhas..."
                  value={busca}
                  onChange={(e) => setBusca(e.target.value)}
                  className="w-25"
                />
                <Button
                  color="light"
                  className="fw-semibold"
                  onClick={() => fetchCampanhas(1, busca)}
                >
                  Buscar
                </Button>
              </div>

              <div className="table-responsive">
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="info" />
                  </div>
                ) : (
                  <table className="table align-middle table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">Nome</th>
                        <th scope="col">Status</th>
                        <th scope="col">Datas</th>
                        <th scope="col">Vouchers</th>
                        <th scope="col" style={{ width: "150px" }}>
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {campanhas.map((campanha) => (
                        <tr key={campanha.id}>
                          <td>
                            <div className="fw-medium">{campanha.nome}</div>
                            <div className="text-muted small">
                              {campanha.descricao}
                            </div>
                          </td>
                          <td>
                            <span
                              className={`badge bg-${
                                campanha.ativo ? "success" : "danger"
                              } bg-opacity-10 text-${
                                campanha.ativo ? "success" : "danger"
                              }`}
                            >
                              {campanha.ativo ? "Ativo" : "Desativado"}
                            </span>
                          </td>
                          <td>
                            <div>
                              Criação:{" "}
                              {new Date(
                                campanha.created_at
                              ).toLocaleDateString()}
                            </div>
                            <div>
                              Validade:{" "}
                              {new Date(campanha.validade).toLocaleDateString()}
                            </div>
                          </td>
                          <td>
                            <div>Ativos: {campanha.nao_usados || 0}</div>
                            <div>Total: {campanha.total_vouchers || 0}</div>
                            <div className="text-muted small">
                              {campanha.percentual_usados?.toFixed(0) || 0}%
                              resgatados
                            </div>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Button
                                color="light"
                                size="sm"
                                className="btn-icon"
                                onClick={() => handleEditarCampanha(campanha)}
                              >
                                <i className="ri-pencil-line"></i>
                              </Button>
                              {campanha.ativo && (
                                <Button
                                  color="danger"
                                  size="sm"
                                  className="btn-icon"
                                  onClick={() =>
                                    handleDesativarCampanha(campanha)
                                  }
                                >
                                  <i className="ri-delete-bin-line"></i>
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              <AwesomePagination
                pagina={pagina}
                totalPaginas={totalPaginas}
                setPagina={setPagina}
              />
            </>
          )}
        </CardBody>
      </Card>

      <ModalCampanha
        isOpen={modalOpen}
        toggle={toggleModal}
        onSuccess={() => fetchCampanhas(pagina, busca)}
      />

      <SidebarCampanha
        isOpen={sidebarOpen}
        toggle={toggleSidebar}
        campanha={campanhaAtual}
        onSuccess={() => {
          fetchCampanhas(pagina, busca);
          setSidebarOpen(false);
        }}
      />

      <ModalConfirmacao
        isOpen={modalConfirmacaoOpen}
        toggle={toggleModalConfirmacao}
        onConfirm={confirmarDesativacao}
        title="Desativar Campanha"
        message="Tem certeza que deseja desativar esta campanha? Esta ação não poderá ser desfeita."
      />
    </>
  );
};

export default TabCampanhas;
